<!--<div [ngClass]="theme === 'light' ? 'light' : 'dark'" appThemeToggleHint>-->
  <div [ngClass]="theme === 'light' ? 'light' : 'dark'">
    <div class="container" (click)="toggleTheme()">
      <div class="bullet">
      <span class="material-icons notranslate icon">
        {{ theme === 'light' ? 'light_mode' : 'dark_mode' }}
      </span>
      </div>
    </div>
  </div>





